import { Sidebar } from '../components/Sidebar';
import { Texts } from '../constants/Texts';
import styles from '../assets/styles/pages/Approval.module.scss';
import { useCustomerContext } from '../context/Customer';
import { FixedSpace } from '../components/FixedSpace';
import { generateCertification, getMessage } from '../api/action';
import * as routes from '../routing/routes';
import { useNavigate } from 'react-router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Form, Formik, FormikProps } from 'formik';
import { InputField } from '../components/InputField';
import { SelectionBar } from '../components/SelectionBar';
import { Button } from '../components/Button';
import classNames from 'classnames';

interface CommunicationFormData {
  email: string;
  phoneNumber: string;
}

const initialValues: CommunicationFormData = {
  email: '',
  phoneNumber: '',
};

export const Approval = () => {
  const customerContext = useCustomerContext();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [validationType, setValidationType] = useState('email');
  const formicRef = useRef<FormikProps<CommunicationFormData>>(null);
  const isEmail = validationType === 'email';
  const [loading, setLoading] = useState(false);

  const onChangeValidationType = (value: string) => {
    setValidationType(value);
  };

  useEffect(() => {
    formicRef.current?.resetForm({
      values: {
        ...formicRef.current?.values,
        email: '',
        phoneNumber: '',
      },
    });
    formicRef.current?.validateForm();
  }, [validationType]);

  const isEmailInvalid = (email: string) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email) ? '' : Texts.INVALID_EMAIL;
  };

  const validate = useCallback(
    (values: CommunicationFormData) => {
      const errors: any = {};
      errors.missingRequierdFileds = isEmail ? !values.email : !values.phoneNumber;
      if (!validateFields(values)) errors.notValid = true;

      if (isEmail && values.email) {
        errors.email = isEmailInvalid(values.email);
      }

      return errors.missingRequierdFileds || errors.notValid ? errors : null || errors.email;
    },
    // eslint-disable-next-line
    [isEmail]
  );

  const validateFields = (value: CommunicationFormData) => {
    if (!(Number(value.phoneNumber) || !isEmailInvalid(value.email).length)) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (pathname != customerContext.currentPosition) {
      customerContext.setCurrentPosition(routes.home);
      navigate(routes.home);
    }
  }, [pathname]);

  useEffect(() => {
    if (customerContext.currentPosition != routes.approval) navigate(customerContext.currentPosition!);
  }, [customerContext.currentPosition]);

  const approval = async (values: CommunicationFormData) => {
    setLoading(true);
    const response = await generateCertification(
      customerContext.code || '',
      customerContext.userData?.carNumber || '',
      values.phoneNumber || '',
      values.email || '',
      1
    );
    if (response) {
      if (response.properties.action_value !== '0') {
        if (!customerContext.checkTimer()) {
          customerContext.setCurrentPosition(routes.expiration);
          return;
        }
        const message = await getMessage(response.properties.action_value);
        alert(String(message));
      } else {
        customerContext.setCurrentPosition(routes.confirmation);
      }
    } else {
      console.error('error', response);
    }
    setLoading(false);
  };

  const formatCarNumber = (number: string) => {
    let formatNumber = '';
    if (number.length === 7) {
      formatNumber = number.slice(0, 2) + '-' + number.slice(2, 5) + '-' + number.slice(5, 7);
    } else {
      formatNumber = number.slice(0, 3) + '-' + number.slice(3, 5) + '-' + number.slice(5, 8);
    }
    return formatNumber;
  };

  return (
    <Formik innerRef={formicRef} validateOnMount={true} initialValues={initialValues} onSubmit={approval} validate={validate}>
      {(formic) => (
        <Form className={styles.main}>
          <Sidebar firstHeader={Texts.CREATE_APPROVAL} secondHeader={Texts.PROTEXTION_CERTIFICATES} />
          <div className={styles.container}>
            <div className={styles.centered}>
              <div className={classNames(styles.onlyMobile, styles.space)} />
              <div className={styles.message}>{Texts.SELECT_COMMUNICATION_CHANNEL}</div>

              <SelectionBar
                firstSelection={{ label: Texts.EMAIL, value: 'email' }}
                secondSelection={{ label: Texts.PHONE_NUMBER, value: 'phone' }}
                onChange={onChangeValidationType}
                value={validationType}
              />

              <FixedSpace height={'1rem'} />

              {isEmail ? (
                <InputField name='email' placeHolder={Texts.ENTER_EMAIL} />
              ) : (
                <InputField name='phoneNumber' placeHolder={Texts.ENTER_PHONE_NUMBER} numeric />
              )}
              <FixedSpace height={'1rem'} />

              <div className={classNames(styles.message, styles.approvalMessage)}>
                {Texts.CLICK_APPROVAL}
                <br />
                {Texts.TO_CREATE_APPROVAL}
              </div>

              <div className={styles.carNumber}>{formatCarNumber(customerContext.userData?.carNumber || '0000000')}</div>
              <div className={classNames(styles.onlyMobile, styles.space)} />

              <Button text={Texts.APPROVAL} isValid={formic.isValid} loading={loading} color='#0f1337' />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
